"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTable = exports.MaterialTableUnstyled = void 0;
const table_head_1 = require("client/components/material/table/table-head");
const material_ui_1 = require("material-ui");
const Table_1 = require("material-ui/Table");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const table_row_1 = require("./table-row");
require("./table.less");
const decorate = material_ui_1.withStyles(theme => ({
    root: {},
    clickable: {
        cursor: "pointer"
    }
}));
let MaterialTableUnstyled = class MaterialTableUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.blankRow = (colspan) => (React.createElement(table_row_1.MaterialTableRow, { key: 1 },
            React.createElement(Table_1.TableCell, { colSpan: colspan }, "No Rows")));
    }
    render() {
        const { classes, clickable = false, columns, order, orderBy, noMargin = false, onRequestSort, rows, renderRow, renderBlankRow = this.blankRow, wideHeader = true } = this.props;
        // const className = noMargin ? '' : 'margin-';
        const className = "";
        /** Connor
         * I broke out the header from the main table because MaterialUI doesnt want its tables headers to be sticky
         * The column widths are lined up in the .less files
         */
        return (React.createElement("div", { className: "table" },
            React.createElement(Table_1.default, { className: "test", style: { position: "sticky", top: 0, zIndex: 1 } },
                React.createElement(table_head_1.MaterialTableHead, { checkbox: this.props.checkbox, columns: columns, order: order, orderBy: orderBy, onRequestSort: onRequestSort })),
            React.createElement("div", null,
                React.createElement(Table_1.default, { classes: { root: clickable ? classes.clickable : classes.root } },
                    React.createElement(Table_1.TableBody, { className: "table__body" }, rows.length === 0
                        ? renderBlankRow(columns.length)
                        : rows.map(renderRow))))));
    }
};
MaterialTableUnstyled = __decorate([
    mobx_react_1.observer
], MaterialTableUnstyled);
exports.MaterialTableUnstyled = MaterialTableUnstyled;
exports.MaterialTable = decorate(MaterialTableUnstyled);
// return (
//   <div className="table">
//     {wideHeader && <div className="table__dummy-header" />}
//     <div className={`table__container table__${className}container`}>
//       <Table
//         classes={{ root: clickable ? classes.clickable : classes.root }}
//       >
//         <MaterialTableHead
//           // style={{ position: 'sticky', top: 0 }}
//           checkbox={this.props.checkbox}
//           columns={columns}
//           order={order}
//           orderBy={orderBy}
//           onRequestSort={onRequestSort}
//         />
//         <TableBody className="table__body">
//           {rows.length === 0
//             ? renderBlankRow(columns.length)
//             : rows.map(renderRow)}
//         </TableBody>
//       </Table>
//     </div>
//   </div>
// );



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/table/table.tsx
// module id = 3268
// module chunks = 0